'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('style-inject');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styleInject__default = /*#__PURE__*/_interopDefaultLegacy(styleInject);

var css_248z = ".Disclosure-module_header__UjM05{align-items:center;display:flex;justify-content:space-between}.Disclosure-module_body__9481S{padding:1rem 0}";
var styles = {"header":"Disclosure-module_header__UjM05","body":"Disclosure-module_body__9481S"};
styleInject__default["default"](css_248z);

exports["default"] = styles;
